import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { ApiStateComponent } from './features/api-state/api-state.component';
import { AppShellComponent } from './features/app-shell/app-shell.component';
import { ChartsDemoComponent } from './features/charts-demo/charts-demo.component';
import { TableExampleComponent } from './features/dashboard/components/table-example/table-example.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'email-response/:incidentNumber',
    loadComponent: () =>
      import('./features/email-response/email-response.component').then(
        (m) => m.EmailResponseComponent
      ),
  },
  {
    path: 'auth',
    children: [
      {
        path: 'callback',
        loadComponent: () =>
          import('./features/auth-callback/auth-callback.component').then(
            (m) => m.AuthCallbackComponent
          ),
      },
    ],
  },
  {
    path: '',
    component: AppShellComponent,
    data: { breadcrumb: 'home' },
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
        data: { breadcrumb: 'Dashboard' },
      },
      {
        path: 'employee-investigation',
        data: { breadcrumb: 'Employee Investigation' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./shared/components/work-in-progress/work-in-progress.component').then(
                (m) => m.WorkInProgressComponent
              ),
            data: {
              title: 'Employee Investigation',
              description: 'This route is a placeholder for the Employee Investigation feature.',
              backLink: '/',
            },
          },
          {
            path: 'case-investigation',
            loadComponent: () =>
              import('./features/variance-tracker/case-investigation/case-investigation.component').then(
                (m) => m.CaseInvestigationComponent
              ),
            data: { breadcrumb: 'Case Investigation' },
          },
          {
            path: 'case-investigation/:caseId',
            loadComponent: () =>
              import('./features/variance-tracker/case-investigation/case-investigation.component').then(
                (m) => m.CaseInvestigationComponent
              ),
            data: { breadcrumb: 'Case Investigation' },
          },
        ],
      },
      {
        path: 'midas-ai-videos',
        loadComponent: () =>
          import('./shared/components/work-in-progress/work-in-progress.component').then(
            (m) => m.WorkInProgressComponent
          ),
        data: {
          breadcrumb: 'Midas AI Videos',
          title: 'Midas AI Videos',
          description: 'This route is a placeholder for the Midas AI Videos feature.',
          backLink: '/',
        },
      },
      {
        path: 'feature-comparison',
        loadComponent: () =>
          import('./features/feature-comparison/feature-comparison.component').then(
            (m) => m.FeatureComparisonComponent
          ),
        data: {
          breadcrumb: 'Feature Comparison',
        },
      },
      {
        path: 'case-investigation-tracker',
        loadComponent: () =>
          import('./features/case-investigation-tracker/case-investigation-tracker.component').then(
            (m) => m.CaseInvestigationTrackerComponent
          ),
        data: { breadcrumb: 'Case Investigation Tracker' },
      },
      {
        path: 'variance-tracker',
        loadComponent: () =>
          import('./features/variance-tracker/variance-tracker-shell/variance-tracker-shell.component').then(
            (m) => m.VarianceTrackerShellComponent
          ),
        data: { breadcrumb: 'Variance Tracker' },
        loadChildren: () =>
          import('./features/variance-tracker/variance-tracker.routes').then(
            (m) => m.varianceTrackerRoutes
          ),
      },
      //TODO: THIS ROUTE IS FOR TESTING PORPUSES NEED TO BE REMOVED AFTER TESTING
      {
        path: 'table-example',
        component: TableExampleComponent,
        data: { breadcrumb: 'Table Example' },
      },
      {
        path: 'charts',
        component: ChartsDemoComponent,
      },
      {
        path: 'analytics',
        loadComponent: () =>
          import('./shared/components/work-in-progress/work-in-progress.component').then(
            (m) => m.WorkInProgressComponent
          ),
        data: {
          breadcrumb: 'Analytics',
          title: 'Analytics',
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import('./shared/components/work-in-progress/work-in-progress.component').then(
                (m) => m.WorkInProgressComponent
              ),
          },
        ],
      }
    ],
  },
  {
    path: 'api/status',
    component: ApiStateComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
